import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../api";
import Model from "../../models/bilets";
import validateForm from "../../lib/helpers/validateForm";
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../lib/helpers/strings";
import {
  getDateFormat,
  getDateReturnDaysString
} from "../../lib/helpers/dates";
import { sortOnCreatedAt } from "../../lib/helpers/sort";

// UI
import {
  Alerts,
  Box,
  Button,
  Input,
  Header,
  HeaderPage,
  Table,
  Row,
  Col,
  ButtonGroup,
  HR,
  Dropdown,
  P,
  Modal
} from "../../ui";

class BiletEditPage extends Component {
  state = {
    titleHeader: "Изменение залогового билета",
    bilet: {},
    historys: [],
    form: {
      bilet_number: {
        value: "",
        isEdited: false,
        isError: false,
        errors: []
      },
      filial_id: { value: "", isEdited: false, isError: false, errors: [] },
      depositor_id: { value: "", isEdited: false, isError: false, errors: [] },
      user_id: { value: "", isEdited: false, isError: false, errors: [] },
      date_created: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.date_created
      },
      date_return: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.date_return
      },
      days: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.days
      },
      days_new: {
        value: "",
        isEdited: false,
        isNumber: true,
        isError: false,
        errors: [],
        validate: Model.days_new
      },
      sum_items: {
        value: "",
        isEdited: false,
        isNumber: true,
        isSum: true,
        isError: false,
        errors: [],
        validate: Model.sum_items
      },
      sum_give: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isSum: true,
        isError: false,
        errors: [],
        validate: Model.sum_give
      },
      percent: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isSum: true,
        isError: false,
        errors: [],
        validate: Model.percent
      },
      sum_percent: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isSum: true,
        isError: false,
        errors: [],
        validate: Model.sum_percent
      },
      sum_return: {
        value: "0",
        isEdited: false,
        isNumber: true,
        isSum: true,
        isError: false,
        errors: [],
        validate: Model.sum_return
      },
      comment: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.comment
      },
      hash: { value: "", isEdited: false, isError: false, errors: [] },
      hash_old: { value: "", isEdited: false, isError: false, errors: [] },
      created_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.created_at
      },
      updated_at: {
        value: "",
        isEdited: false,
        isDate: true,
        isError: false,
        errors: [],
        validate: Model.updated_at
      }
    },
    formFines: {},
    formAddFine: {
      isVisible: false,
      isDisabled: false,
      form: {
        _type: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.fines.type_fyne
        },
        days_fine: {
          value: "0",
          isEdited: false,
          isNumber: true,
          isError: false,
          errors: [],
          validate: Model.fines.days_fine
        },
        percent_fine: {
          value: "0",
          isEdited: false,
          isNumber: true,
          isSum: true,
          isError: false,
          errors: [],
          validate: Model.fines.percent_fine
        },
        sum_fine: {
          value: "0",
          isEdited: false,
          isNumber: true,
          isSum: true,
          isError: false,
          errors: [],
          validate: Model.fines.sum_fine
        },
        historyId: {
          value: "",
          isEdited: false,
          isError: false,
          errors: [],
          validate: Model.fines.historyId
        }
      }
    },
    headers: {
      fine: [
        { title: "Тип" },
        { title: "Процент штрафа" },
        { title: "Кол-во дней штрафа" },
        { title: "Сумма" },
        { title: "Дата создания" },
        { title: "Дата обновления" },
        { title: "Действия", colSpan: 2, text: "center" }
      ]
    },
    modals: {
      deleteFine: {
        title: "Удаление штрафа",
        yesTitle: "Удалить штраф",
        yesClassName: "error",
        isShow: false,
        selectedFineId: null,
        selectedFineItem: null,
        yesDisabled: false
      }
    },
    buttons: {
      save: {
        disabled: false,
        title: "Изменить билет"
      }
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;
    const bilet = await API.bilets.getOne(id);

    if (bilet && bilet.bilet_number) {
      const { form, formFines } = this.state;

      // Заполняем форму
      for (let key in form) {
        // Если филиал
        if (key === "filial_id") {
          form[key].value = bilet[key].name;
        } else if (key === "depositor_id" || key === "user_id") {
          form[key].value = fioLitleTruncateFromObject(bilet[key]);
        } else {
          if (form[key].isNumber) {
            form[key].value = String(bilet[key]) || "0";
          } else if (form[key].isDate) {
            form[key].value = getDateFormat(bilet[key]);
          } else {
            form[key].value = bilet[key] || "";
          }
        }
      }

      // Штрафы
      if (bilet && bilet.fine && bilet.fine.length) {
        // Сортируем штрафы
        bilet.fine.sort(sortOnCreatedAt);

        // Заполняем форму
        for (let fine of bilet.fine) {
          if (fine._type && fine._type === "lost") {
            formFines[fine._id] = {
              _type: {
                value: fine._type,
                isEdited: false,
                isError: false,
                errors: [],
                validate: Model.fines.type_fyne
              },
              sum_fine: {
                value: String(fine.sum_fine) || "0",
                isEdited: false,
                isNumber: true,
                isSum: true,
                isError: false,
                errors: [],
                validate: Model.fines.sum_fine
              },
              created_at: {
                value: getDateFormat(fine.created_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.created_at
              },
              updated_at: {
                value: getDateFormat(fine.updated_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.updated_at
              }
            };
          } else {
            formFines[fine._id] = {
              _type: {
                value: fine._type,
                isEdited: false,
                isError: false,
                errors: [],
                validate: Model.fines.type_fyne
              },
              days_fine: {
                value: String(fine.days_fine) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.fines.days_fine
              },
              percent_fine: {
                value: String(fine.percent_fine) || "0",
                isEdited: false,
                isNumber: true,
                isSum: true,
                isError: false,
                errors: [],
                validate: Model.fines.percent_fine
              },
              sum_fine: {
                value: String(fine.sum_fine) || "0",
                isEdited: false,
                isNumber: true,
                isSum: true,
                isError: false,
                errors: [],
                validate: Model.fines.sum_fine
              },
              created_at: {
                value: getDateFormat(fine.created_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.created_at
              },
              updated_at: {
                value: getDateFormat(fine.updated_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.updated_at
              }
            };
          }
        }
      }

      const historys = await API.bilets.getBiletHistorys(id);

      if (historys && historys.length) {
        historys.sort(sortOnCreatedAt);
      }

      this.setState({ historys });

      this.setState({ bilet, form, formFines });
    }
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleDatepicker = (name, value) => {
    console.log("handleDatepicker in page:", name, value);

    this.setState(prevState => {
      return {
        form: {
          ...prevState.form,
          [name]: {
            ...prevState.form[name],
            value,
            isEdited: true,
            isError: false,
            errors: []
          }
        }
      };
    });
  };

  handleInputFine = e => {
    let value = e.target.value;
    let [id, name] = String(e.target.name).split(":");
    const { formFines } = this.state;

    if (id && formFines[id] && formFines[id][name]) {
      if (formFines[id][name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          formFines: {
            ...prevState.formFines,
            [id]: {
              ...prevState.formFines[id],
              [name]: {
                ...prevState.formFines[id][name],
                value,
                isEdited: true,
                isError: false,
                errors: []
              }
            }
          }
        };
      });
    }
  };

  handleInputFineAdd = e => {
    let { value, name } = e.target;
    const { form } = this.state.formAddFine;

    if (form[name] && form[name].isNumber) {
      value = String(value) || "";
    }

    this.setState(prevState => {
      return {
        formAddFine: {
          ...prevState.formAddFine,
          form: {
            ...prevState.formAddFine.form,
            [name]: {
              ...prevState.formAddFine.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        }
      };
    });
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      const { save } = this.state.buttons;
      save.disabled = true;

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, save },
          loading: true
        };
      });

      save.disabled = false;

      const { form } = this.state;
      const { id } = this.props.match.params;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        // Изменение текущего
        const resultUpdated = await API.bilets.editOne(id, {
          ...optionsRequest
        });

        if (resultUpdated) {
          Alerts.success("Билет изменён");

          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("Билет не изменён");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });
        }
      } else {
        Alerts.alert("В билете нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: { ...prevState.buttons, save }
          };
        });

        this.props.history.goBack();
      }
    }
  };

  handleAddFineVisible = async e => {
    e.preventDefault();

    const { formAddFine } = this.state;

    // Делаем видимой
    formAddFine.isVisible = !formAddFine.isVisible;

    for (let field in formAddFine.form) {
      formAddFine.form[field].value = "";
      formAddFine.form[field].isEdited = false;
      formAddFine.form[field].isError = false;
      formAddFine.form[field].errors = [];
    }

    this.setState({
      formAddFine
    });
  };

  handleAddFineFormSubmit = async e => {
    e.preventDefault();

    console.log("----------------", "handleAddFineFormSubmit");

    const result = validateForm(this.state.formAddFine.form);

    console.log("----------------", "result");

    this.setState(prevState => {
      return {
        formAddFine: {
          ...prevState.formAddFine,
          form: result.form
        }
      };
    });

    // Success
    if (result.valid) {
      console.log("----------------", "result valid");

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          formAddFine: {
            ...prevState.formAddFine,
            isDisabled: true
          }
        };
      });

      const { form } = this.state.formAddFine;
      const biletId = this.props.match.params.id;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      console.log("----------------", "1");

      // Есть изменения?
      if (Object.keys(optionsRequest).length) {
        console.log(
          "----------------",
          "1 true",
          "form:",
          form,
          "optionsRequest:",
          optionsRequest
        );

        // Изменение текущего
        const newFine = await API.bilets.createFine(biletId, {
          ...optionsRequest
        });

        console.log("----------------", "new fine", newFine);

        if (newFine) {
          console.log("----------------", "new fine created");

          Alerts.success("Штраф создан");

          const { formAddFine, formFines, bilet } = this.state;

          // Скрыть таблицу создания штрафа
          // Делаем не видимой
          formAddFine.isVisible = false;

          // Очистить поля
          for (let field in formAddFine.form) {
            formAddFine.form[field].value = "";
            formAddFine.form[field].isEdited = false;
            formAddFine.form[field].isError = false;
            formAddFine.form[field].errors = [];
          }

          // // Включаем кнопку
          formAddFine.isDisabled = false;

          // Добавляем новый штраф
          bilet.fine.push(newFine);
          // Сортируем штрафы
          bilet.fine.sort(sortOnCreatedAt);

          // Добавить новый штраф в штрафы
          if (newFine._type === "lost") {
            formFines[newFine._id] = {
              _type: {
                value: newFine._type,
                isEdited: false,
                isError: false,
                errors: [],
                validate: Model.fines.type_fyne
              },
              sum_fine: {
                value: String(newFine.sum_fine) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.fines.sum_fine
              },
              created_at: {
                value: getDateFormat(newFine.created_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.created_at
              },
              updated_at: {
                value: getDateFormat(newFine.updated_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.updated_at
              }
            };
          } else {
            formFines[newFine._id] = {
              _type: {
                value: newFine._type,
                isEdited: false,
                isError: false,
                errors: [],
                validate: Model.fines.type_fyne
              },
              days_fine: {
                value: String(newFine.days_fine) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.fines.days_fine
              },
              percent_fine: {
                value: String(newFine.percent_fine) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.fines.percent_fine
              },
              sum_fine: {
                value: String(newFine.sum_fine) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.fines.sum_fine
              },
              created_at: {
                value: getDateFormat(newFine.created_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.created_at
              },
              updated_at: {
                value: getDateFormat(newFine.updated_at),
                isEdited: false,
                isDate: true,
                isError: false,
                errors: [],
                validate: Model.fines.updated_at
              }
            };
          }

          // const newFormFines = sortBiletFormFines(formFines)

          console.log("----------------", "SUCCESS", formFines);

          // Включаем кнопку, данные сохранились
          // this.setState({formAddFine});
          this.setState({ formAddFine, formFines, bilet });
        } else {
          console.log("----------------", "new fine false");

          Alerts.error("Штраф не создан. Попробуйте ещё раз.");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              formAddFine: {
                ...prevState.formAddFine,
                isDisabled: false
              }
            };
          });
        }
      } else {
        console.log("----------------", "1 false");

        Alerts.alert("В штрафе не заполнены поля");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            formAddFine: {
              ...prevState.formAddFine,
              isDisabled: false
            }
          };
        });
      }
    } else {
      console.log("----------------", "result invalid");
      console.log("----------------", result);
    }
  };

  handleFineEditDelete = async e => {
    e.preventDefault();
    // let value = e.target.value;
    let [fineId, name] = String(e.target.name).split(":");

    if (name === "edit") {
      const result = validateForm(this.state.formFines[fineId]);

      this.setState(prevState => {
        return {
          formFines: {
            ...prevState.formFines,
            [fineId]: {
              ...prevState.formFines[fineId],
              ...result.form
            }
          }
        };
      });

      // Success
      if (result.valid) {
        const { formFines } = this.state;
        const optionsRequest = {};

        for (let idInFormFines in formFines) {
          if (fineId === idInFormFines) {
            for (let nameItem in formFines[fineId]) {
              if (formFines[fineId][nameItem].isEdited) {
                optionsRequest[nameItem] = formFines[fineId][nameItem].value;
              }
            }
          }
        }

        // Есть изменения?
        if (Object.keys(optionsRequest).length) {
          // Изменение текущего
          const biletId = this.props.match.params.id;
          const resultUpdated = await API.bilets.editFine(biletId, fineId, {
            ...optionsRequest
          });

          if (resultUpdated) {
            Alerts.success("Штраф изменён");
          } else {
            Alerts.error("Штраф не изменён");
          }
        } else {
          Alerts.info("В штрафе нет изменений");
        }
      } else {
        Alerts.warn("Валидация...");
      }
    }
  };

  handleSelectDropdown = (item, name) => {
    if (item && item.id) {
      if (name === "_type") {
        this.setState(prevState => {
          const isValidateFields = item.id === "delay";

          console.log(
            "name:",
            name,
            "item:",
            item,
            "isValidateFields",
            isValidateFields
          );

          return {
            formAddFine: {
              ...prevState.formAddFine,
              form: {
                ...prevState.formAddFine.form,
                days_fine: {
                  ...prevState.formAddFine.form.days_fine,
                  validate: {
                    ...prevState.formAddFine.form.days_fine.validate,
                    required: isValidateFields,
                    isNumber: isValidateFields,
                    isNumberInteger: isValidateFields,
                    isNumberPositive: isValidateFields
                  }
                },
                percent_fine: {
                  ...prevState.formAddFine.form.percent_fine,
                  validate: {
                    ...prevState.formAddFine.form.percent_fine.validate,
                    required: isValidateFields,
                    isNumber: isValidateFields,
                    isNumberPositive: isValidateFields
                  }
                },
                [name]: {
                  ...prevState.form[name],
                  value: String(item.id),
                  isEdited: true,
                  isError: false,
                  errors: []
                }
              }
            }
          };
        });
      } else {
        this.setState(prevState => {
          return {
            formAddFine: {
              ...prevState.formAddFine,
              form: {
                ...prevState.formAddFine.form,
                [name]: {
                  ...prevState.form[name],
                  value: String(item.id),
                  isEdited: true,
                  isError: false,
                  errors: []
                }
              }
            }
          };
        });
      }
    }
  };

  handleModalOpen = (selectedFineId, selectedFineItem) => {
    const fine = {};
    for (let key in selectedFineItem) {
      if (selectedFineItem[key].isNumber) {
        fine[key] = String(selectedFineItem[key].value) || "";
      } else if (selectedFineItem[key].isDate) {
        fine[key] = getDateFormat(selectedFineItem[key].value);
      } else if (selectedFineItem[key].isSum) {
        fine[key] = sumFormat(selectedFineItem[key].value);
      } else {
        fine[key] = selectedFineItem[key].value;
      }
    }

    this.setState(prevState => {
      return {
        modals: {
          ...prevState.modals,
          deleteFine: {
            ...prevState.modals.deleteFine,
            isShow: true,
            selectedFineId,
            selectedFineItem: fine
          }
        }
      };
    });
  };

  handleModalClose = () => {
    this.setState(prevState => {
      return {
        modals: {
          ...prevState.modals,
          deleteFine: {
            ...prevState.modals.deleteFine,
            isShow: false,
            selectedFineId: null,
            selectedFineItem: null
          }
        }
      };
    });
  };

  handleDeleteFine = async e => {
    e.preventDefault();

    const { selectedFineId } = this.state.modals.deleteFine;
    // Удаление штрафа
    const biletId = this.props.match.params.id;
    const resultDeleted = await API.bilets.deleteFine(biletId, selectedFineId);

    // Штраф удалён
    if (resultDeleted) {
      const { formFines, bilet } = this.state;
      const formFinesNew = {};

      // Переформируем штрафы
      for (let key in formFines) {
        if (key !== selectedFineId) {
          formFinesNew[key] = formFines[key];
        }
      }

      // Убираем штраф из билета
      bilet.fine = bilet.fine.filter(fine => {
        return fine._id !== selectedFineId;
      });

      this.setState(prevState => {
        return {
          formFines: formFinesNew,
          bilet,
          modals: {
            ...prevState.modals,
            deleteFine: {
              ...prevState.modals.deleteFine,
              isShow: false,
              selectedFineId: null,
              selectedFineItem: null
            }
          }
        };
      });

      Alerts.success("Штраф удалён");
    } else {
      Alerts.error("Штраф не удалён");
    }
  };

  render() {
    const { bilet, form, formFines, formAddFine, historys } = this.state;

    const headersFineAdd = [
      { title: "Тип" },
      { title: "Процент", suffix: "штрафа" },
      { title: "Кол-во дней", suffix: "штрафа" },
      { title: "Сумма" },
      { title: "Дата", suffix: "операции" },
      { title: "Действия", colSpan: 2, text: "center" }
    ];
    let finesList = [];
    if (formFines && Object.keys(formFines)) {
      for (let fineId in formFines) {
        finesList.push(
          <tr key={fineId}>
            <td>
              {formFines[fineId]._type.value === "lost"
                ? "Потеря билета"
                : "Задержка билета"}
            </td>
            <td>
              {formFines[fineId]._type.value === "delay" ? (
                <Input
                  label="Кол-во дней штрафа"
                  type="integer"
                  name={`${fineId}:days_fine`}
                  value={formFines[fineId].days_fine.value}
                  errors={formFines[fineId].days_fine.errors}
                  handleChange={this.handleInputFine}
                />
              ) : (
                "Тип = потеря билета"
              )}
            </td>
            <td>
              {formFines[fineId]._type.value === "delay" ? (
                <Input
                  label="Процент штрафа"
                  type="number"
                  name={`${fineId}:percent_fine`}
                  value={formFines[fineId].percent_fine.value}
                  errors={formFines[fineId].percent_fine.errors}
                  handleChange={this.handleInputFine}
                />
              ) : (
                "Тип = потеря билета"
              )}
            </td>
            <td>
              <Input
                label="Сумма штрафа"
                type="number"
                name={`${fineId}:sum_fine`}
                value={formFines[fineId].sum_fine.value}
                errors={formFines[fineId].sum_fine.errors}
                handleChange={this.handleInputFine}
              />
            </td>
            <td>
              <Input
                label="Дата создания"
                name={`${fineId}:created_at`}
                type="date"
                dateTop={true}
                dateRight={true}
                value={formFines[fineId].created_at.value}
                errors={formFines[fineId].created_at.errors}
                handleChange={this.handleInputFine}
                // handleChangeDate={this.handleDatepicker}
              />
            </td>
            <td>
              <Input
                label="Дата обновления"
                name={`${fineId}:updated_at`}
                type="date"
                dateTop={true}
                dateRight={true}
                value={formFines[fineId].updated_at.value}
                errors={formFines[fineId].updated_at.errors}
                handleChange={this.handleInputFine}
                // handleChangeDate={this.handleDatepicker}
              />
            </td>
            <td>
              <Button
                type="button"
                theme="success"
                size="s"
                name={`${fineId}:edit`}
                onClick={this.handleFineEditDelete}
              >
                Сохранить
              </Button>
            </td>
            <td>
              <Button
                type="button"
                theme="error"
                size="s"
                name={`${fineId}:delete`}
                onClick={() => this.handleModalOpen(fineId, formFines[fineId])}
              >
                Удалить
              </Button>
            </td>
          </tr>
        );
      }
    }

    let dropdownHash = [];
    if (historys.length) {
      dropdownHash = historys
        .filter(item => item._method !== "create")
        .map(item => {
          return {
            id: item._id,
            title: getDateFormat(item.created_at),
            onSelect: true,
            select: true
          };
        });
    } else {
      dropdownHash.push({
        type: "text",
        title: "Список операций пуст",
        size: "small"
      });
    }

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <HeaderPage
            title={this.state.titleHeader + " №" + form.bilet_number.value}
            back={this.props.history.goBack}
          >
            <ButtonGroup>
              <Button
                type="submit"
                theme="success"
                disabled={this.state.buttons.save.disabled}
              >
                {this.state.buttons.save.title}
              </Button>
              <Button
                type="button"
                onClick={() => this.props.history.goBack()}
                theme="default"
              >
                Отмена
              </Button>
            </ButtonGroup>
          </HeaderPage>

          <Box>
            <Header size={2} margin="no-top">
              Изменение текущего состояния
            </Header>

            <Row>
              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Главное
                </Header>

                <Input
                  label="Номер з/б:"
                  name="bilet_number"
                  value={this.state.form.bilet_number.value}
                  disabled={true}
                />
                <Input
                  label="Филиал:"
                  name="filial_id"
                  value={this.state.form.filial_id.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-left">
                <Header size={5} margin="no-top">
                  Сроки
                </Header>

                <Input
                  label="Первая операция:"
                  name="date_created"
                  type="date"
                  value={this.state.form.date_created.value}
                  errors={this.state.form.date_created.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Дата возврата:"
                  name="date_return"
                  type="date"
                  value={this.state.form.date_return.value}
                  errors={this.state.form.date_return.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Всего дней:"
                  type="integer"
                  name="days"
                  value={this.state.form.days.value}
                  errors={this.state.form.days.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Когда возврат:"
                  name="days_return"
                  value={getDateReturnDaysString(
                    this.state.form.date_return.value,
                    true
                  )}
                  disabled={true}
                />
                {bilet.status === "continue" ? (
                  <Input
                    label="Продлён на:"
                    name="days_new"
                    value={this.state.form.days_new.value}
                    errors={this.state.form.days_new.errors}
                    handleChange={this.handleInput}
                  />
                ) : null}
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Деньги
                </Header>

                <Input
                  label="Сумма оценки:"
                  type="number"
                  name="sum_items"
                  value={this.state.form.sum_items.value}
                  errors={this.state.form.sum_items.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Сумма выдачи:"
                  type="number"
                  name="sum_give"
                  value={this.state.form.sum_give.value}
                  errors={this.state.form.sum_give.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Используемый процент:"
                  type="number"
                  name="percent"
                  value={this.state.form.percent.value}
                  errors={this.state.form.percent.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Сумма процентов:"
                  type="number"
                  name="sum_percent"
                  value={this.state.form.sum_percent.value}
                  errors={this.state.form.sum_percent.errors}
                  handleChange={this.handleInput}
                />
                <Input
                  label="Сумма возврата:"
                  type="number"
                  name="sum_return"
                  value={this.state.form.sum_return.value}
                  errors={this.state.form.sum_return.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Header size={5} margin="no-top">
                  Люди
                </Header>

                <Input
                  label="Залогодатель:"
                  name="depositor_id"
                  value={this.state.form.depositor_id.value}
                  disabled={true}
                />
                <Input
                  label="Ответсвенный:"
                  name="user_id"
                  value={this.state.form.user_id.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-right">
                <Header size={5} margin="no-top">
                  Изменения
                </Header>

                <Input
                  label="Дата создания з/б:"
                  name="created_at"
                  type="date"
                  dateRight={true}
                  value={this.state.form.created_at.value}
                  errors={this.state.form.created_at.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
                <Input
                  label="Дата обновления з/б:"
                  name="updated_at"
                  type="date"
                  dateRight={true}
                  value={this.state.form.updated_at.value}
                  errors={this.state.form.updated_at.errors}
                  handleChange={this.handleInput}
                  handleChangeDate={this.handleDatepicker}
                />
              </Col>
            </Row>

            <br />

            <Row>
              <Col padding="no-top-left">
                <Input
                  label="Комментарий"
                  name="comment"
                  value={this.state.form.comment.value}
                  placeholder="Комментарий не задан"
                  errors={this.state.form.comment.errors}
                  handleChange={this.handleInput}
                />
              </Col>

              <Col padding="no-top">
                <Input
                  label="HASH-текущий:"
                  name="hash"
                  value={this.state.form.hash.value}
                  disabled={true}
                />
              </Col>

              <Col padding="no-top-right">
                <Input
                  label="HASH-предыдущий:"
                  name="hash_old"
                  value={this.state.form.hash_old.value}
                  disabled={true}
                />
              </Col>
            </Row>
          </Box>
        </form>

        <Box>
          <Header size={4}>Штрафы</Header>
          {finesList && finesList.length ? (
            <Table headers={this.state.headers.fine} isResponsive={false}>
              {finesList}
            </Table>
          ) : (
            "Список пуст"
          )}

          <br />
          <HR theme="dashed" mutted={true} />

          {this.state.historys && this.state.historys.length > 1 ? (
            <div>
              <br />
              {this.state.formAddFine.isVisible ? (
                <form className="form" onSubmit={this.handleAddFineFormSubmit}>
                  <Table headers={headersFineAdd} isResponsive={false}>
                    <tr key="fine-add-inputs">
                      <td>
                        <Dropdown
                          type="select"
                          block={true}
                          top={true}
                          label="Тип штрафа"
                          errors={formAddFine.form._type.errors}
                          list={[
                            {
                              id: "delay",
                              title: "Задержка билета",
                              onSelect: true,
                              select: true
                            },
                            {
                              id: "lost",
                              title: "Потеря билета",
                              onSelect: true,
                              select: true
                            }
                          ]}
                          selectedId={formAddFine.form._type.value}
                          onSelect={item => {
                            this.handleSelectDropdown(item, "_type");
                          }}
                          required
                        />
                      </td>
                      <td>
                        {formAddFine.form._type.value === "delay" ? (
                          <Input
                            label="Кол-во дней штрафа"
                            type="integer"
                            name="days_fine"
                            value={formAddFine.form.days_fine.value}
                            errors={formAddFine.form.days_fine.errors}
                            handleChange={this.handleInputFineAdd}
                          />
                        ) : (
                          "Тип = потеря билета"
                        )}
                      </td>
                      <td>
                        {formAddFine.form._type.value === "delay" ? (
                          <Input
                            label="Процент штрафа"
                            type="number"
                            name="percent_fine"
                            value={formAddFine.form.percent_fine.value}
                            errors={formAddFine.form.percent_fine.errors}
                            handleChange={this.handleInputFineAdd}
                          />
                        ) : (
                          "Тип = потеря билета"
                        )}
                      </td>
                      <td>
                        <Input
                          label="Сумма штрафа"
                          type="number"
                          name="sum_fine"
                          value={formAddFine.form.sum_fine.value}
                          errors={formAddFine.form.sum_fine.errors}
                          handleChange={this.handleInputFineAdd}
                        />
                      </td>
                      <td>
                        <Dropdown
                          type="select"
                          block={true}
                          top={true}
                          right={true}
                          label="Выберите дату операции"
                          errors={formAddFine.form.historyId.errors}
                          list={dropdownHash}
                          selectedId={formAddFine.form.historyId.value}
                          onSelect={item => {
                            this.handleSelectDropdown(item, "historyId");
                          }}
                          required
                        />
                      </td>
                      <td>
                        <Button
                          type="submit"
                          theme="success"
                          block={true}
                          disabled={this.state.formAddFine.isDisabled}
                        >
                          Создать штраф
                        </Button>
                      </td>
                      <td>
                        <Button
                          type="button"
                          theme="default"
                          block={true}
                          onClick={this.handleAddFineVisible}
                        >
                          Отменить
                        </Button>
                      </td>
                    </tr>
                  </Table>
                </form>
              ) : (
                <Button
                  type="button"
                  theme="primary"
                  block
                  outline
                  onClick={this.handleAddFineVisible}
                >
                  Новый штраф
                </Button>
              )}

              <Modal
                title={this.state.modals.deleteFine.title}
                show={this.state.modals.deleteFine.isShow}
                yesTitle={this.state.modals.deleteFine.yesTitle}
                yesHandlerOnClick={this.handleDeleteFine}
                yesThemeButton={this.state.modals.deleteFine.yesClassName}
                yesDisabled={this.state.modals.deleteFine.yesDisabled}
                noHandlerOnClick={this.handleModalClose}
              >
                <P>Вы действительно хотите удалить штраф?</P>

                {this.state.modals.deleteFine.selectedFineId ? (
                  <Table
                    headers={this.state.headers.fine.filter((value, index) => {
                      return index !== this.state.headers.fine.length - 1;
                    })}
                  >
                    <tr
                      key={`delete-fine-in-modal-${this.state.modals.deleteFine.selectedFineId}`}
                    >
                      <td>
                        {this.state.formFines[
                          this.state.modals.deleteFine.selectedFineId
                        ]._type.value === "lost"
                          ? "Потеря билета"
                          : "Задержка билета"}
                      </td>
                      <td>
                        {this.state.formFines[
                          this.state.modals.deleteFine.selectedFineId
                        ]._type.value === "delay"
                          ? this.state.formFines[
                              this.state.modals.deleteFine.selectedFineId
                            ].days_fine.value
                          : "Тип = потеря билета"}
                      </td>
                      <td>
                        {this.state.formFines[
                          this.state.modals.deleteFine.selectedFineId
                        ]._type.value === "delay"
                          ? this.state.formFines[
                              this.state.modals.deleteFine.selectedFineId
                            ].percent_fine.value
                          : "Тип = потеря билета"}
                      </td>
                      <td>
                        {sumFormat(
                          this.state.formFines[
                            this.state.modals.deleteFine.selectedFineId
                          ].sum_fine.value
                        )}
                      </td>
                      <td>
                        {
                          this.state.formFines[
                            this.state.modals.deleteFine.selectedFineId
                          ].created_at.value
                        }
                      </td>
                      <td>
                        {
                          this.state.formFines[
                            this.state.modals.deleteFine.selectedFineId
                          ].updated_at.value
                        }
                      </td>
                    </tr>
                  </Table>
                ) : null}
              </Modal>
            </div>
          ) : (
            <P margin="no-top">
              В истории существует только одна операцию. Нельзя создать штраф
              для начальной операции.
            </P>
          )}
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(BiletEditPage));
